import React, { Component } from "react";
import DefaultComponent from "../util/StyledComponents/DefaultComponent";
class Incidents extends Component {
  render() {
    return <DefaultComponent>INCIDENTS</DefaultComponent>;
  }
}

export default Incidents;
